import { render, staticRenderFns } from "./pd-hero-features.vue?vue&type=template&id=e664b8ce&"
import script from "./pd-hero-features.vue?vue&type=script&lang=js&"
export * from "./pd-hero-features.vue?vue&type=script&lang=js&"
import style0 from "./pd-hero-features.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports